export default "__VITE_ASSET__CjMKxbfC__"